export const createRow = function (h) {
  return h(
    'Row',
    {
      props: {
        gutter: 24,
      },
    },
    [...createCol.call(this, h)]
  );
};

export const createCol = function (h) {
  const { columns = [], formData, showDetails, span } = this.props;

  if (Array.isArray(columns) && columns.length) {
    return columns.map((column) => {
      const { formItemClass = {} } = column;

      return h(
        'Col',
        {
          props: {
            span: column.span || span || 12,
            ...column,
          },
          key: column.prop,
        },
        [
          column.element !== 'searchBtn' ?
            h(
              'FormItem',
              {
                class: {
                  ...formItemClass,
                  bt_margin_zero: !column.label,
                },
                props: {
                  ...column,

                },
              },
              [
                createTags.call(this, h, {
                  column,
                  showDetails,
                  row: formData,
                }),
                createTip.call(this, h, column),
              ]
            ) : renderSearchBtn(h, column)
        ]
      );
    });
  }
  return [];
};

export function createTags(h, { column, row = {}, showDetails }) {
  let VNode = null;
  const scopedSlots = this.data.scopedSlots;
  const slots = this.slots && this.slots();

  if (scopedSlots && column.prop && scopedSlots[column.prop]) {
    VNode = scopedSlots[column.prop]({ row, column });
  } else if (slots && column.prop && slots[column.prop]) {
    VNode = slots[column.prop];
  }

  if (VNode) return VNode;

  return h('BaseItem', {
    props: {
      row,
      column,
      showDetails,
    },
  });
}

// 提示语
function createTip(h, column) {
  if (!column.tip) return null;

  return h(
    'Tooltip',
    {
      class: {
        no_white_space: true,
      },
      props: {
        placement: 'top-start',
        content: column.tip,
      },
    },
    [
      h('Icon', {
        props: {
          type: 'ios-help-circle-outline',
        },
      }),
    ]
  );
}

// render 表单搜索按钮
function renderSearchBtn(h, column) {
  if (column.render instanceof Function) {
    return column.render(h, column)
  }
  return ""
}
